
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import { VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TProductAggregatedFilter } from '../../types/product-aggregated';
  import { getBasePeriodsInfo } from '../../utils/base-info/periods';
  import { getBaseTreeInfo } from '../../utils/base-info/tree';
  import BaseInfo from '../common/base-info/BaseInfo.vue';
  import { TBaseInfoItem } from '../common/base-info/types';

  export default defineComponent({
    name: 'ProductAggregatedBaseInfo',
    components: {
      BaseInfo,
    },
    props: {
      filter: {
        type: Object as PropType<TProductAggregatedFilter>,
        required: true,
      },
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
        getRegionsRfTree: VED_COMMON_GETTERS_NAME.getRegionsRfTree,
      }),
      getItems(): TBaseInfoItem[] {
        return [this.getPeriodsItem, this.getCountriesItem, this.getRegionsRfItem];
      },
      getPeriodsItem(): TBaseInfoItem {
        return {
          label: 'Период',
          value: getBasePeriodsInfo(this.filter.periods),
          isLoading: false,
        };
      },
      getCountriesItem(): TBaseInfoItem {
        return {
          label: 'Страна-партнер',
          value: getBaseTreeInfo(this.getCountriesTree, this.filter.countries),
          isLoading: !this.getCountriesTree.length,
        };
      },
      getRegionsRfItem(): TBaseInfoItem {
        return {
          label: 'Субъект РФ',
          value: getBaseTreeInfo(this.getRegionsRfTree, this.filter.regionsRf),
          isLoading: !this.getRegionsRfTree.length,
        };
      },
    },
  });
